import instance from '@/utils/instance';

//标准明细信息
export function getStandardDet(params) {
	return instance({
		url: `/webL_api/essential/api/standardBasicInfo/${params}`,
		method: 'get'
	});
}

//标准明细-是否被收藏
export function getStandardDetIsCollect(params) {
    return instance({
        url: `/webL_api/consumer/member/book/queryCollect/${params}`,
        method: 'get'
    });
}

//标准明细-取消收藏
export function getStandardDetRemoveCollect(params) {
    return instance({
        url: `/webL_api/consumer/member/book/removeCollect/${params}`,
        method: 'get'
    });
}

//替代标准信息
export function getReplaceStandardDet(params) {
    return instance({
        url: `/webL_api/essential/api/standardReplaceInfo/${params}`,
        method: 'get'
    });
}

//被替代标准信息
export function getReplacedStandardDet(params) {
    return instance({
        url: `/webL_api/essential/api/replaceStandardInfo/${params}`,
        method: 'get'
    });
}

//引用标准信息
export function getQuoteStandardDet(params) {
    return instance({
        url: `/webL_api/essential/api/standardQuoteInfo/${params}`,
        method: 'get'
    });
}

//标准历史节点信息
export function getStandardHistoryDet(params) {
    return instance({
        url: `/webL_api/essential/api/standardHistoryInfo/${params}`,
        method: 'get'
    });
}

//采用标准信息
export function getAdoptStandardDet(params) {
    return instance({
        url: `/webL_api/essential/api/standardAdoptInfo/${params}`,
        method: 'get'
    });
}


